import React from 'react';
import './Loading.css';

export const Loading = (props) => {
  return (
    <div className="cssload-loader">
      <div>
        <div className="sk-fading-circle">
          <div className="sk-circle1 sk-circle"/>
          <div className="sk-circle2 sk-circle"/>
          <div className="sk-circle3 sk-circle"/>
          <div className="sk-circle4 sk-circle"/>
          <div className="sk-circle5 sk-circle"/>
          <div className="sk-circle6 sk-circle"/>
          <div className="sk-circle7 sk-circle"/>
          <div className="sk-circle8 sk-circle"/>
          <div className="sk-circle9 sk-circle"/>
          <div className="sk-circle10 sk-circle"/>
          <div className="sk-circle11 sk-circle"/>
          <div className="sk-circle12 sk-circle"/>
        </div>
      </div>
      <div>
        <span className="text-center text-xs body-lighter text-white mt-4">{ props.message || 'Cargando ...' }</span>
      </div>
    </div>
  )
}

export default Loading;
